import { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { Text } from '@spotify-internal/encore-web';
import { ErrorBoundary } from '@spotify/confidence-core-react';
import { useTaskSuspense } from '@spotify/plugin-confidence-issues-react';

const TaskRedirectContent = () => {
  const { id = '' } = useParams<{ id: string }>();
  const { task } = useTaskSuspense({ name: `tasks/${id}` });

  if (!task.resource) {
    return (
      <Text as="p" variant="bodyMedium" semanticColor="textSubdued">
        This task has no associated resource.
      </Text>
    );
  }

  return <Navigate to={`/${task.resource}/tasks/${id}`} replace />;
};

export const TaskRedirect = () => (
  <ErrorBoundary
    renderFallback={({ message }) => (
      <Text as="p" variant="bodyMedium" semanticColor="textSubdued">
        Could not load task. {message}
      </Text>
    )}
  >
    <Suspense
      fallback={
        <Text as="p" variant="bodyMedium" semanticColor="textSubdued">
          Loading task...
        </Text>
      }
    >
      <TaskRedirectContent />
    </Suspense>
  </ErrorBoundary>
);
